import { FamilyMember } from "../../utils/familyTreeUtils";

// Helper function to add progress tracking fields to template data
function addProgressFields(data: any[]): FamilyMember[] {
  function addFieldsRecursive(member: any): FamilyMember {
    return {
      ...member,
      editStatus: "template" as const,
      completionScore: 0,
      isCustomAdded: false,
      parents: member.parents
        ? member.parents.map(addFieldsRecursive)
        : undefined,
      children: member.children
        ? member.children.map(addFieldsRecursive)
        : undefined,
    };
  }

  return data.map(addFieldsRecursive);
}

// Raw template data (without progress fields)
const rawFamilyTreeData = [
  {
    id: "self",
    name: "Your Name",
    birthdate: "YYYY-MM-DD",
    imageMetadata: "Placeholder for image metadata",
    spouseId: "spouse",
    parents: [
      {
        id: "father",
        name: "Father's Name",
        birthdate: "YYYY-MM-DD",
        imageMetadata: "Placeholder for image metadata",
        spouseId: "mother",
        parents: [
          {
            id: "paternal-grandfather",
            name: "Paternal Grandfather's Name",
            birthdate: "YYYY-MM-DD",
            imageMetadata: "Placeholder for image metadata",
            spouseId: "paternal-grandmother",
            parents: [
              {
                id: "paternal-great-grandfather",
                name: "Paternal Great Grandfather's Name",
                birthdate: "YYYY-MM-DD",
                imageMetadata: "Placeholder for image metadata",
                spouseId: "paternal-great-grandmother",
                parents: [
                  {
                    id: "paternal-great-great-grandfather",
                    name: "Paternal Great Great Grandfather's Name",
                    birthdate: "YYYY-MM-DD",
                    imageMetadata: "Placeholder for image metadata",
                    spouseId: "paternal-great-great-grandmother",
                  },
                  {
                    id: "paternal-great-great-grandmother",
                    name: "Paternal Great Great Grandmother's Name",
                    birthdate: "YYYY-MM-DD",
                    imageMetadata: "Placeholder for image metadata",
                    spouseId: "paternal-great-great-grandfather",
                  },
                ],
              },
              {
                id: "paternal-great-grandmother",
                name: "Paternal Great Grandmother's Name",
                birthdate: "YYYY-MM-DD",
                imageMetadata: "Placeholder for image metadata",
                spouseId: "paternal-great-grandfather",
                parents: [
                  {
                    id: "paternal-great-grandmother-father",
                    name: "Paternal Great Grandmother's Father's Name",
                    birthdate: "YYYY-MM-DD",
                    imageMetadata: "Placeholder for image metadata",
                    spouseId: "paternal-great-grandmother-mother",
                  },
                  {
                    id: "paternal-great-grandmother-mother",
                    name: "Paternal Great Grandmother's Mother's Name",
                    birthdate: "YYYY-MM-DD",
                    imageMetadata: "Placeholder for image metadata",
                    spouseId: "paternal-great-grandmother-father",
                  },
                ],
              },
            ],
          },
          {
            id: "paternal-grandmother",
            name: "Paternal Grandmother's Name",
            birthdate: "YYYY-MM-DD",
            imageMetadata: "Placeholder for image metadata",
            spouseId: "paternal-grandfather",
            parents: [
              {
                id: "paternal-great-grandfather-mother-side",
                name: "Paternal Great Grandfather (Mother's Side) Name",
                birthdate: "YYYY-MM-DD",
                imageMetadata: "Placeholder for image metadata",
                spouseId: "paternal-great-grandmother-mother-side",
                parents: [
                  {
                    id: "paternal-great-grandfather-mother-side-father",
                    name: "Paternal Great Grandfather (Mother's Side) Father's Name",
                    birthdate: "YYYY-MM-DD",
                    imageMetadata: "Placeholder for image metadata",
                    spouseId: "paternal-great-grandfather-mother-side-mother",
                  },
                  {
                    id: "paternal-great-grandfather-mother-side-mother",
                    name: "Paternal Great Grandfather (Mother's Side) Mother's Name",
                    birthdate: "YYYY-MM-DD",
                    imageMetadata: "Placeholder for image metadata",
                    spouseId: "paternal-great-grandfather-mother-side-father",
                  },
                ],
              },
              {
                id: "paternal-great-grandmother-mother-side",
                name: "Paternal Great Grandmother (Mother's Side) Name",
                birthdate: "YYYY-MM-DD",
                imageMetadata: "Placeholder for image metadata",
                spouseId: "paternal-great-grandfather-mother-side",
                parents: [
                  {
                    id: "paternal-great-grandmother-mother-side-father",
                    name: "Paternal Great Grandmother (Mother's Side) Father's Name",
                    birthdate: "YYYY-MM-DD",
                    imageMetadata: "Placeholder for image metadata",
                    spouseId: "paternal-great-grandmother-mother-side-mother",
                  },
                  {
                    id: "paternal-great-grandmother-mother-side-mother",
                    name: "Paternal Great Grandmother (Mother's Side) Mother's Name",
                    birthdate: "YYYY-MM-DD",
                    imageMetadata: "Placeholder for image metadata",
                    spouseId: "paternal-great-grandmother-mother-side-father",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "mother",
        name: "Mother's Name",
        birthdate: "YYYY-MM-DD",
        imageMetadata: "Placeholder for image metadata",
        spouseId: "father",
        parents: [
          {
            id: "maternal-grandfather",
            name: "Maternal Grandfather's Name",
            birthdate: "YYYY-MM-DD",
            imageMetadata: "Placeholder for image metadata",
            spouseId: "maternal-grandmother",
            parents: [
              {
                id: "maternal-great-grandfather",
                name: "Maternal Great Grandfather's Name",
                birthdate: "YYYY-MM-DD",
                imageMetadata: "Placeholder for image metadata",
                spouseId: "maternal-great-grandmother",
                parents: [
                  {
                    id: "maternal-great-great-grandfather",
                    name: "Maternal Great Great Grandfather's Name",
                    birthdate: "YYYY-MM-DD",
                    imageMetadata: "Placeholder for image metadata",
                    spouseId: "maternal-great-great-grandmother",
                  },
                  {
                    id: "maternal-great-great-grandmother",
                    name: "Maternal Great Great Grandmother's Name",
                    birthdate: "YYYY-MM-DD",
                    imageMetadata: "Placeholder for image metadata",
                    spouseId: "maternal-great-great-grandfather",
                  },
                ],
              },
              {
                id: "maternal-great-grandmother",
                name: "Maternal Great Grandmother's Name",
                birthdate: "YYYY-MM-DD",
                imageMetadata: "Placeholder for image metadata",
                spouseId: "maternal-great-grandfather",
                parents: [
                  {
                    id: "maternal-great-grandmother-father",
                    name: "Maternal Great Grandmother's Father's Name",
                    birthdate: "YYYY-MM-DD",
                    imageMetadata: "Placeholder for image metadata",
                    spouseId: "maternal-great-grandmother-mother",
                  },
                  {
                    id: "maternal-great-grandmother-mother",
                    name: "Maternal Great Grandmother's Mother's Name",
                    birthdate: "YYYY-MM-DD",
                    imageMetadata: "Placeholder for image metadata",
                    spouseId: "maternal-great-grandmother-father",
                  },
                ],
              },
            ],
          },
          {
            id: "maternal-grandmother",
            name: "Maternal Grandmother's Name",
            birthdate: "YYYY-MM-DD",
            imageMetadata: "Placeholder for image metadata",
            spouseId: "maternal-grandfather",
            parents: [
              {
                id: "maternal-great-grandfather-mother-side",
                name: "Maternal Great Grandfather (Mother's Side) Name",
                birthdate: "YYYY-MM-DD",
                imageMetadata: "Placeholder for image metadata",
                spouseId: "maternal-great-grandmother-mother-side",
                parents: [
                  {
                    id: "maternal-great-grandfather-mother-side-father",
                    name: "Maternal Great Grandfather (Mother's Side) Father's Name",
                    birthdate: "YYYY-MM-DD",
                    imageMetadata: "Placeholder for image metadata",
                    spouseId: "maternal-great-grandfather-mother-side-mother",
                  },
                  {
                    id: "maternal-great-grandfather-mother-side-mother",
                    name: "Maternal Great Grandfather (Mother's Side) Mother's Name",
                    birthdate: "YYYY-MM-DD",
                    imageMetadata: "Placeholder for image metadata",
                    spouseId: "maternal-great-grandfather-mother-side-father",
                  },
                ],
              },
              {
                id: "maternal-great-grandmother-mother-side",
                name: "Maternal Great Grandmother (Mother's Side) Name",
                birthdate: "YYYY-MM-DD",
                imageMetadata: "Placeholder for image metadata",
                spouseId: "maternal-great-grandfather-mother-side",
                parents: [
                  {
                    id: "maternal-great-grandmother-mother-side-father",
                    name: "Maternal Great Grandmother (Mother's Side) Father's Name",
                    birthdate: "YYYY-MM-DD",
                    imageMetadata: "Placeholder for image metadata",
                    spouseId: "maternal-great-grandmother-mother-side-mother",
                  },
                  {
                    id: "maternal-great-grandmother-mother-side-mother",
                    name: "Maternal Great Grandmother (Mother's Side) Mother's Name",
                    birthdate: "YYYY-MM-DD",
                    imageMetadata: "Placeholder for image metadata",
                    spouseId: "maternal-great-grandmother-mother-side-father",
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: "spouse",
    name: "Spouse Name",
    birthdate: "2000-01-01",
    imageMetadata: "Placeholder for image metadata",
    spouseId: "self",
    parents: [
      {
        id: "spouse-father",
        name: "Spouse's Father's Name",
        birthdate: "YYYY-MM-DD",
        imageMetadata: "Placeholder for image metadata",
        spouseId: "spouse-mother",
        parents: [
          {
            id: "spouse-paternal-grandfather",
            name: "Spouse's Paternal Grandfather's Name",
            birthdate: "YYYY-MM-DD",
            imageMetadata: "Placeholder for image metadata",
            spouseId: "spouse-paternal-grandmother",
            parents: [
              {
                id: "spouse-paternal-great-grandfather",
                name: "Spouse's Paternal Great Grandfather's Name",
                birthdate: "YYYY-MM-DD",
                imageMetadata: "Placeholder for image metadata",
                spouseId: "spouse-paternal-great-grandmother",
                parents: [
                  {
                    id: "spouse-paternal-great-grandfather-father",
                    name: "Spouse's Paternal Great Grandfather's Father's Name",
                    birthdate: "YYYY-MM-DD",
                    imageMetadata: "Placeholder for image metadata",
                    spouseId: "spouse-paternal-great-grandfather-mother",
                  },
                  {
                    id: "spouse-paternal-great-grandfather-mother",
                    name: "Spouse's Paternal Great Grandfather's Mother's Name",
                    birthdate: "YYYY-MM-DD",
                    imageMetadata: "Placeholder for image metadata",
                    spouseId: "spouse-paternal-great-grandfather-father",
                  },
                ],
              },
              {
                id: "spouse-paternal-great-grandmother",
                name: "Spouse's Paternal Great Grandmother's Name",
                birthdate: "YYYY-MM-DD",
                imageMetadata: "Placeholder for image metadata",
                spouseId: "spouse-paternal-great-grandfather",
                parents: [
                  {
                    id: "spouse-paternal-great-grandmother-father",
                    name: "Spouse's Paternal Great Grandmother's Father's Name",
                    birthdate: "YYYY-MM-DD",
                    imageMetadata: "Placeholder for image metadata",
                    spouseId: "spouse-paternal-great-grandmother-mother",
                  },
                  {
                    id: "spouse-paternal-great-grandmother-mother",
                    name: "Spouse's Paternal Great Grandmother's Mother's Name",
                    birthdate: "YYYY-MM-DD",
                    imageMetadata: "Placeholder for image metadata",
                    spouseId: "spouse-paternal-great-grandmother-father",
                  },
                ],
              },
            ],
          },
          {
            id: "spouse-paternal-grandmother",
            name: "Spouse's Paternal Grandmother's Name",
            birthdate: "YYYY-MM-DD",
            imageMetadata: "Placeholder for image metadata",
            spouseId: "spouse-paternal-grandfather",
            parents: [
              {
                id: "spouse-paternal-grandmother-father",
                name: "Spouse's Paternal Grandmother's Father's Name",
                birthdate: "YYYY-MM-DD",
                imageMetadata: "Placeholder for image metadata",
                spouseId: "spouse-paternal-grandmother-mother",
                parents: [
                  {
                    id: "spouse-paternal-grandmother-father-father",
                    name: "Spouse's Paternal Grandmother's Father's Father's Name",
                    birthdate: "YYYY-MM-DD",
                    imageMetadata: "Placeholder for image metadata",
                    spouseId: "spouse-paternal-grandmother-father-mother",
                  },
                  {
                    id: "spouse-paternal-grandmother-father-mother",
                    name: "Spouse's Paternal Grandmother's Father's Mother's Name",
                    birthdate: "YYYY-MM-DD",
                    imageMetadata: "Placeholder for image metadata",
                    spouseId: "spouse-paternal-grandmother-father-father",
                  },
                ],
              },
              {
                id: "spouse-paternal-grandmother-mother",
                name: "Spouse's Paternal Grandmother's Mother's Name",
                birthdate: "YYYY-MM-DD",
                imageMetadata: "Placeholder for image metadata",
                spouseId: "spouse-paternal-grandmother-father",
                parents: [
                  {
                    id: "spouse-paternal-grandmother-mother-father",
                    name: "Spouse's Paternal Grandmother's Mother's Father's Name",
                    birthdate: "YYYY-MM-DD",
                    imageMetadata: "Placeholder for image metadata",
                    spouseId: "spouse-paternal-grandmother-mother-mother",
                  },
                  {
                    id: "spouse-paternal-grandmother-mother-mother",
                    name: "Spouse's Paternal Grandmother's Mother's Mother's Name",
                    birthdate: "YYYY-MM-DD",
                    imageMetadata: "Placeholder for image metadata",
                    spouseId: "spouse-paternal-grandmother-mother-father",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "spouse-mother",
        name: "Spouse's Mother's Name",
        birthdate: "YYYY-MM-DD",
        imageMetadata: "Placeholder for image metadata",
        spouseId: "spouse-father",
        parents: [
          {
            id: "spouse-maternal-grandfather",
            name: "Spouse's Maternal Grandfather's Name",
            birthdate: "YYYY-MM-DD",
            imageMetadata: "Placeholder for image metadata",
            spouseId: "spouse-maternal-grandmother",
            parents: [
              {
                id: "spouse-maternal-grandfather-father",
                name: "Spouse's Maternal Grandfather's Father's Name",
                birthdate: "YYYY-MM-DD",
                imageMetadata: "Placeholder for image metadata",
                spouseId: "spouse-maternal-grandfather-mother",
                parents: [
                  {
                    id: "spouse-maternal-grandfather-father-father",
                    name: "Spouse's Maternal Grandfather's Father's Father's Name",
                    birthdate: "YYYY-MM-DD",
                    imageMetadata: "Placeholder for image metadata",
                    spouseId: "spouse-maternal-grandfather-father-mother",
                  },
                  {
                    id: "spouse-maternal-grandfather-father-mother",
                    name: "Spouse's Maternal Grandfather's Father's Mother's Name",
                    birthdate: "YYYY-MM-DD",
                    imageMetadata: "Placeholder for image metadata",
                    spouseId: "spouse-maternal-grandfather-father-father",
                  },
                ],
              },
              {
                id: "spouse-maternal-grandfather-mother",
                name: "Spouse's Maternal Grandfather's Mother's Name",
                birthdate: "YYYY-MM-DD",
                imageMetadata: "Placeholder for image metadata",
                spouseId: "spouse-maternal-grandfather-father",
                parents: [
                  {
                    id: "spouse-maternal-grandfather-mother-father",
                    name: "Spouse's Maternal Grandfather's Mother's Father's Name",
                    birthdate: "YYYY-MM-DD",
                    imageMetadata: "Placeholder for image metadata",
                    spouseId: "spouse-maternal-grandfather-mother-mother",
                  },
                  {
                    id: "spouse-maternal-grandfather-mother-mother",
                    name: "Spouse's Maternal Grandfather's Mother's Mother's Name",
                    birthdate: "YYYY-MM-DD",
                    imageMetadata: "Placeholder for image metadata",
                    spouseId: "spouse-maternal-grandfather-mother-father",
                  },
                ],
              },
            ],
          },
          {
            id: "spouse-maternal-grandmother",
            name: "Spouse's Maternal Grandmother's Name",
            birthdate: "YYYY-MM-DD",
            imageMetadata: "Placeholder for image metadata",
            spouseId: "spouse-maternal-grandfather",
            parents: [
              {
                id: "spouse-maternal-grandmother-father",
                name: "Spouse's Maternal Grandmother's Father's Name",
                birthdate: "YYYY-MM-DD",
                imageMetadata: "Placeholder for image metadata",
                spouseId: "spouse-maternal-grandmother-mother",
                parents: [
                  {
                    id: "spouse-maternal-grandmother-father-father",
                    name: "Spouse's Maternal Grandmother's Father's Father's Name",
                    birthdate: "YYYY-MM-DD",
                    imageMetadata: "Placeholder for image metadata",
                    spouseId: "spouse-maternal-grandmother-father-mother",
                  },
                  {
                    id: "spouse-maternal-grandmother-father-mother",
                    name: "Spouse's Maternal Grandmother's Father's Mother's Name",
                    birthdate: "YYYY-MM-DD",
                    imageMetadata: "Placeholder for image metadata",
                    spouseId: "spouse-maternal-grandmother-father-father",
                  },
                ],
              },
              {
                id: "spouse-maternal-grandmother-mother",
                name: "Spouse's Maternal Grandmother's Mother's Name",
                birthdate: "YYYY-MM-DD",
                imageMetadata: "Placeholder for image metadata",
                spouseId: "spouse-maternal-grandmother-father",
                parents: [
                  {
                    id: "spouse-maternal-grandmother-mother-father",
                    name: "Spouse's Maternal Grandmother's Mother's Father's Name",
                    birthdate: "YYYY-MM-DD",
                    imageMetadata: "Placeholder for image metadata",
                    spouseId: "spouse-maternal-grandmother-mother-mother",
                  },
                  {
                    id: "spouse-maternal-grandmother-mother-mother",
                    name: "Spouse's Maternal Grandmother's Mother's Mother's Name",
                    birthdate: "YYYY-MM-DD",
                    imageMetadata: "Placeholder for image metadata",
                    spouseId: "spouse-maternal-grandmother-mother-father",
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
];

export const familyTreeData = addProgressFields(rawFamilyTreeData);
